import * as Type from 'library/ts/utilities/modules/Type';
export const launch = (element) => {
    if (Type.isElement(element) && fullScreenEnabled() === true) {
        if (element?.requestFullscreen) {
            element.requestFullscreen();
        }
        else if (element?.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        }
        else if (element?.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        }
        else if (element?.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    }
};
export const exit = () => {
    if (state().active === false)
        return;
    const doc = document;
    if (doc.exitFullscreen) {
        doc.exitFullscreen();
    }
    else if (doc?.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
    }
    else if (doc?.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
    }
    else if (doc?.msExitFullscreen) {
        doc.msExitFullscreen();
    }
};
export const state = () => {
    let fullScreenElement = document?.fullscreenElement || document?.['mozFullScreenElement'] || document?.['webkitFullscreenElement'] || document?.['msFullscreenElement'];
    if (fullScreenElement === null)
        fullScreenElement = undefined;
    return {
        active: Type.isDefined(fullScreenElement),
        element: fullScreenElement,
        enabled: fullScreenEnabled()
    };
};
export const fullScreenEnabled = () => {
    return (document?.fullscreenEnabled
        ||
            document?.['webkitFullscreenEnabled']
        ||
            document?.['mozFullScreenEnabled']
        ||
            document?.['msFullscreenEnabled']);
};
